import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Copy, Check, Loader2 } from "lucide-react";
import { API } from "@/lib/auth";

export default function BridalDepositPanel({ enquiry, onChange }) {
  const [busy, setBusy] = useState(false);
  const payUrl = enquiry.deposit_token ? `${window.location.origin}/bridal/pay/${enquiry.deposit_token}` : null;

  const send = async () => {
    const again = enquiry.deposit_requested_at ? " again" : "";
    if (!window.confirm(`Email ${enquiry.full_name} the booking-fee link${again}? Only do this once you've confirmed the date is available.`)) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/bridal/enquiries/${enquiry.id}/deposit-request`);
      onChange(r.data.enquiry);
      toast.success("Booking-fee link emailed");
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not send the link"); } finally { setBusy(false); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(payUrl); toast.success("Link copied"); } catch { toast.error("Could not copy"); }
  };

  if (enquiry.deposit_paid) {
    return (
      <section data-testid="bridal-deposit-panel" className="rounded-3xl bg-[#EAF6EE] border border-[#BFE3CB] p-5">
        <div className="overline text-[#1E5B33]">Booking fee</div>
        <p data-testid="bridal-deposit-paid" className="mt-2 text-sm text-[#1E5B33] inline-flex items-center gap-2">
          <Check size={14} /> Paid{enquiry.deposit_amount ? ` £${enquiry.deposit_amount}` : ""}{enquiry.deposit_paid_at ? ` on ${new Date(enquiry.deposit_paid_at).toLocaleDateString("en-GB")}` : ""} — date secured
        </p>
      </section>
    );
  }
  return (
    <section data-testid="bridal-deposit-panel" className="rounded-3xl bg-white border border-[hsl(var(--onyx)/0.06)] p-5">
      <div className="overline">Booking fee</div>
      <p className="mt-2 text-xs text-[hsl(var(--onyx)/0.6)]">
        {enquiry.deposit_requested_at
          ? `Link emailed ${new Date(enquiry.deposit_requested_at).toLocaleDateString("en-GB")} — waiting for payment. When she pays, this enquiry is marked paid and moved to Confirmed automatically.`
          : "Once you've checked the date is available, email her a secure payment link. Paying marks the deposit paid and moves her to Confirmed."}
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button onClick={send} disabled={busy} data-testid="bridal-deposit-send-btn" className="text-xs px-4 py-2 rounded-full bg-[#8B1B3A] text-white inline-flex items-center gap-1.5 disabled:opacity-60">
          {busy ? <Loader2 size={12} className="animate-spin" /> : <Send size={12} />} {enquiry.deposit_requested_at ? "Resend booking-fee email" : "Email booking-fee link"}
        </button>
        {payUrl && (
          <button onClick={copy} data-testid="bridal-deposit-copy-btn" className="text-xs px-4 py-2 rounded-full border inline-flex items-center gap-1.5"><Copy size={12} /> Copy link</button>
        )}
      </div>
    </section>
  );
}
